import './MyTrips.styles.scss';
import { Nav } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import useGet from '../../../services/useGet';
import { Property } from '../../../types/property';
import { connect } from 'react-redux';
import { UrbainUser } from '../../../redux/user/user.types';
import { isEmpty } from '../../../utils/utils';
import ActiveTrips from './ActiveTrips/ActiveTrips';
import moment from 'moment';
import PastTrips from './PastTrips/PastTrips';

interface MyTripsProps {
  urbainUser: UrbainUser;
}

function MyTrips({ urbainUser }: MyTripsProps) {
  const [show, setShow] = useState('active');
  const [trips, getTrips] = useGet<Property>({
    url: `/trips/${urbainUser?.UserID}`,
    defaultValue: []
  });
  const [activeTrips, setActiveTrips] = useState<Array<any>>([]);
  const [pastTrips, setPastTrips] = useState<Array<any>>([]);

  useEffect(() => {
    if (urbainUser && !isEmpty(urbainUser)) {
      getTrips();
    }
  }, [urbainUser]);

  useEffect(() => {
    if (trips && trips.length) {
      const active: Array<any> = [];
      const past: Array<any> = [];
      trips.map((eachTrip: any) => {
        if (moment().isAfter(moment(eachTrip.CheckOutDate))) {
          past.push(eachTrip);
        } else {
          active.push(eachTrip);
        }
      });
      if (active && !!active.length) {
        setActiveTrips(active);
      }
      if (past && !!past.length) {
        setPastTrips(past);
      }
      console.log('TRIPS', trips);
    }
  }, [trips]);

  return (
    <div>
      <h3 className={'my-trips-header'}>My Trips</h3>
      <div className={'my-trips-content'}>
        <Nav defaultActiveKey={show} onSelect={(selectedKey: string | null) => setShow(selectedKey || 'active')} className={'pl-3'}>
          <Nav.Item>
            <Nav.Link eventKey="active" className={'urbain-nav-link'}>
              Active
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="past" className={'urbain-nav-link'}>
              Past
            </Nav.Link>
          </Nav.Item>
        </Nav>
        <div className={'border'}>
          {show === 'active' && <ActiveTrips trips={activeTrips} />}
          {show === 'past' && <PastTrips trips={pastTrips} />}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state: any) => ({
  urbainUser: state.user.urbainUser
});

export default connect(mapStateToProps)(MyTrips);
